<template>
  <div class="Radio-menu-box">
    <el-radio-group
      v-for="(item, index) in props.RadioGather"
      :key="index"
      v-model="state.data.Radio[index]"
      @change="searchChange"
      size="large"
      class="menu-item-box"
    >
      <el-radio-button
        v-for="(v, i) in item.childer"
        :key="i"
        :label="v.label"
      ></el-radio-button>
    </el-radio-group>
    <!--  -->
    <span class="seniorQuery select-cancel" @click="RadioCancel">
      {{ "取消选择" }}
    </span>
  </div>
</template>

<script lang="ts">
import { CaretBottom, CaretTop, DataLine } from "@element-plus/icons-vue";
import isArray from "lodash-es/isArray";
import { defineComponent, onMounted, onBeforeMount, reactive, watch, onUnmounted } from "vue";
import type { ComponentPublicInstance, ExtractPropTypes, PropType, SetupContext, StyleValue, VNode } from "vue";
import type { stateData, Value, RadioChilder, RadioGather, RadioGatherType } from "./types";
import $, { post } from "jquery";
import { buildProps } from "../../utils/props";

import { cloneDeep, times } from "lodash-es";
import moment from "moment";
import isEqual from "lodash-es/isEqual";
const NumberRangeProps = buildProps({
  modelValue: {
    type: Object,
    default: () => ({}),
  },
  RadioGather: {
    type: Array,
    default: () => [
      {
        type: "Time",
        key: ["beginForecastTime", "endForecastTime"],
        Defaults: null,
        childer: [
          {
            label: "今日预报",
            TimeDifferenceValue: [0, 0],
          },
          {
            label: "昨日预报",
            TimeDifferenceValue: [-1, -1],
          },
          {
            label: "7日预报",
            TimeDifferenceValue: [0, -7],
          },
          {
            label: "30日预报",
            TimeDifferenceValue: [0, -30],
          },
        ],
      },
      {
        type: "default",
        key: "erpOrderFlag",
        Defaults: null,
        childer: [
          {
            label: "有订单",
            Difference: true,
          },
          {
            label: "无订单",
            Difference: false,
          },
        ],
      },
      {
        type: "default",
        key: "remarkFlag",
        Defaults: null,
        childer: [
          {
            label: "有留言 / 备注",
            Difference: true,
          },
          {
            label: "无留言 / 备注",
            Difference: false,
          },
        ],
      },
    ],
  },
});

type NumberRangePropsType = ExtractPropTypes<typeof NumberRangeProps>;
export default defineComponent({
  // emits: ["update:modelValue"],
  name: "radioGroup",
  props: NumberRangeProps,
  setup(props: NumberRangePropsType, ctx: SetupContext<any>) {
    var state: any = reactive({
      data: {
        Value: {},
        Radio: [],
      },
    });
    // 单选取消
    const RadioCancel = () => {
      state.data.Time = [];
      RadioSte(state.data.Value, true);
      state.data.Radio = [];
      searchChange();
    };
    // 处理单选
    const RadioSte = (data: Value, Cancel = false) => {
      // 遍历当前的 单选组数组
      state.data.Radio.forEach((v: any, i: number) => {
        var target: any = props.RadioGather[i];
        // 如果处理的 是普通单选
        if (target.type !== "Time" && state.data.Radio[i]) {
          // 获取 lable 集合
          let labels: Array<string> = target.childer.map(
            (v: RadioChilder) => v.label
          );
          // 找到 当前的 单选对象索引
          let Index: number = labels.findIndex(
            (v: string) => v === state.data.Radio[i]
          );
          if (Index !== -1) {
            // 进行赋值 或者 清空操作
            if (target.key) {
              data[target.key] = Cancel
                ? null
                : target.childer[Index].Difference;
            }
          }
        } else if (target.type == "Time") {
          // 如若处理的 是时间选择
          // 获取 lable 集合
          let labels: Array<string> = target.childer.map(
            (v: RadioChilder) => v.label
          );
          // 找到 当前的 单选对象索引
          let Index: number = labels.findIndex(
            (v: string) => v === state.data.Radio[i]
          );
          if (Index !== -1) {
            // 进行赋值 或者 清空操作
            if (target.key) {
              let key = target.key;
              let timeDifference = target.childer[Index].TimeDifferenceValue;
              data[key[0]] = Cancel
                ? null
                : moment()
                    .add(timeDifference[0], "days")
                    .format("YYYY-MM-DD ") + " 00:00:00";
              data[key[1]] = Cancel
                ? null
                : moment().add(timeDifference[1], "days").format("YYYY-MM-DD") +
                  " 23:59:59";
            }
          }
        }
      });
    };
    onBeforeMount(() => {
      console.log(props.modelValue);
      firstRenderFn();
    });
    // 初次渲染 => props.modelValue 数据回显
    function firstRenderFn() {
      let initialValue = {};
      props.RadioGather.forEach((item: any, index: number) => {
        switch (item.type) {
          case "Time":
            if (![null, undefined].includes(props.modelValue[item.key[0]])) {
              state.data.Radio[index] = item.label;
              let target: any = item.childer.find((value: any) => {
                let start =
                  moment()
                    .add(value.TimeDifferenceValue[0], "days")
                    .format("YYYY-MM-DD ") + " 00:00:00";
                let end =
                  moment()
                    .add(value.TimeDifferenceValue[1], "days")
                    .format("YYYY-MM-DD") + " 23:59:59";
                if (
                  start === props.modelValue[item.key[0]] &&
                  end === props.modelValue[item.key[1]]
                ) {
                  return true;
                }
              });
              if (target) state.data.Radio[index] = target.label;
            } else {
              state.data.Radio[index] = item.Defaults;
            }
            initialValue[item.key[0]] =
              props.modelValue[item.key[0]] || item.Defaults;
            initialValue[item.key[1]] =
              props.modelValue[item.key[1]] || item.Defaults;
            break;
          default:
            if (![null, undefined].includes(props.modelValue[item.key])) {
              let target: any = item.childer.find(
                (value: any) => value.Difference === props.modelValue[item.key]
              );
              if (target) state.data.Radio[index] = target.label;
            } else {
              state.data.Radio[index] = item.Defaults;
            }
            initialValue[item.key] =
              props.modelValue[item.key] || item.Defaults;
            break;
        }
      });
      state.data.Value = initialValue;
      RadioSte(state.data.Value);
      ctx.emit("update:modelValue", state.data.Value);
    }
    // 搜索值的改变
    function searchChange() {
      // 处理单选
      var data = state.data.Value;
      // 处理单选
      RadioSte(data);
      ctx.emit("update:modelValue", data);
    }
    onUnmounted(() => {
      console.log("组件销毁");
    });
    watch(
      () => props.modelValue,
      (newVal: any) => {
        // 如若返回的值不一样则 =》 重新计算页面值并展示
        if (!isEqual(newVal, state.data.Value)) firstRenderFn();
      }
    );
    return {
      searchChange,
      RadioCancel,
      props,
      state,
    };
  },
});
</script>

<style lang="scss" scoped>
.search-box {
  width: calc(100vw - 200px);
  display: flex;
  .seniorMenuBox {
    flex: 1;
  }
}
:deep( .Tab-filter-Condition-boX ) {
  display: inline-block;
  .select {
    width: 150px;
  }
  .check {
    .el-tag {
      display: none;
    }
    // input {
    //   pla
    // }
  }
  .radio {
    margin: 0 20px 0 20px;
  }
}
:deep( .el-input-number--mini .el-input__inner ) {
  padding: 0;
}
:deep( .el-input-number__increase ) {
  display: none;
}
:deep( .el-input-number__decrease ) {
  display: none;
}
.select-cancel {
  display: inline-block;
  vertical-align: bottom;
}
.box {
  width: 100%;
}
.Radio-menu-box {
  display: inline-block;
  box-sizing: border-box;
  padding: 10px 0 0 20px;
  width: auto !important;
}
:deep( .menu-item-box ) {
  display: inline-block;
  margin-right: 20px;
  .el-radio-button__inner {
    padding: 4px 8px;
  }
}
.seniorMenuBox {
  transition: all 1s;
}
:deep( .scope-select ) {
  width: 240px;
  display: flex;
  flex-wrap: nowrap;
  .left {
    width: 110px;
  }
  .interval {
    display: inline-block;
    padding: 0 6px;
  }
  .right {
    width: 110px;
  }
}
.associated {
  width: 330px;
  display: flex;
  flex-wrap: nowrap;
  .left {
    width: 120px;
    margin-right: 10px;
  }
  .right {
    width: 200px;
  }
}
:deep( .el-form-item ) {
  margin-bottom: 0 !important;
  padding-right: 10px !important;
}
:deep( .fromTimeBox ) {
  width: 320px;
}
:deep( .fromItemBox ) {
  width: 320px;
  input {
    width: 240px;
  }
}
:deep( .el-form-item__label ) {
  padding-left: 10px;
  box-sizing: border-box;
  width: 80px;
}
:deep( .seniorQuery ) {
  cursor: pointer;
  color: #276af4;
  font-size: 12px;
}
.rowStyle {
  margin-bottom: 12px;
}
.itemStyle {
  margin-right: 20px;
}
.seniorBox {
  padding-left: 6px;
  width: 600px;
  display: flex;
  flex-wrap: nowrap;
  .select {
    width: 120px;
  }
  .autocomplete {
  }
  .input {
    width: 240px;
    margin-right: 20px;
  }
}
</style>
